"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyPopover = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const StyledPopover = (0, material_1.styled)(material_1.Popover, {
  shouldForwardProp: prop => prop !== "padding" && prop !== "paperStyle"
})(({
  padding,
  paperStyle
}) => ({
  [`& .${material_1.popoverClasses.paper}`]: Object.assign({
    padding
  }, paperStyle)
}));

const SskyPopover = props => {
  return react_1.default.createElement(StyledPopover, {
    id: props.id,
    PaperProps: props.paperProps,
    className: props.className,
    anchorEl: props.anchor,
    anchorOrigin: props.anchorOrigin,
    transformOrigin: props.transformOrigin,
    open: props.open,
    disableRestoreFocus: props.disableRestoreFocus,
    onClose: props.onClose,
    hideBackdrop: props.hideBackdrop,
    "data-testid": props.dataTestId || `testId-${props.id}`,
    padding: props.padding,
    paperStyle: props.paperStyle
  }, props.children);
};

exports.SskyPopover = SskyPopover;
SskyPopover.defaultProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  disableRestoreFocus: true,
  padding: 24,
  transformOrigin: {
    vertical: "top",
    horizontal: "left"
  }
};
exports.default = react_1.default.memo(SskyPopover);